import { SystemAppNameModel } from "@api/types/systemappname";
import { httpClient } from "../../httpClient";

type Data = any;

const webApi = "/api/v1/systemappname/";

export async function getSystemAppName(): Promise<any> {
  try {
    const { data } = await httpClient.get(webApi);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getSystemAppNameForSelect(): Promise<any> {
  try {
    const { data } = await httpClient.get(`${webApi}forselect/`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getSystemAppNameApprover(id: number): Promise<any> {
  try {
    const { data } = await httpClient.get(`${webApi}approvers/${id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postSystemAppName(
  payload: SystemAppNameModel
): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(webApi, payload);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postSystemAppNameApprover(
  systemAppNameId: number,
  email: string
): Promise<any> {
  try {
    const { data } = await httpClient.post(`${webApi}approver`, {
      email,
      systemAppNameId,
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function deleteSystemAppApproverById(id: number) {
  try {
    const { data } = await httpClient.delete(`${webApi}approvers/${id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function putSystemAppName(
  id: number,
  payload: SystemAppNameModel
): Promise<any> {
  try {
    const { data } = await httpClient.put<Data>(`${webApi}${id}`, payload);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const systemappname = {
  getSystemAppName,
  getSystemAppNameForSelect,
  getSystemAppNameApprover,
  postSystemAppName,
  postSystemAppNameApprover,
  deleteSystemAppApproverById,
  putSystemAppName,
};
